import React from 'react';
import { ClockIcon, HeartIcon, LightbulbIcon, UsersIcon } from 'lucide-react';
type PainCard = {
  title: string;
  text: string;
  icon: React.ElementType;
  /** Fondo y color del ícono */
  tone: {
    bg: string;
    fg: string;
  };
};
const painCopy = {
  eyebrow: '¿Te toca organizar el Baby Shower?',
  title: 'Que todo salga lindo, divertido y organizado… sin complicarte.',
  subtitle: 'Con este kit tenés los juegos preparados para lucirte y compartir un momento hermoso con amigas y familia.'
};
const painCards: PainCard[] = [{
  title: "¿No sabés qué juegos elegir?",
  text: "Tranquila, ya los pensamos por vos. Tenés 30 juegos imprimibles y 50 dinámicas de regalo para que tu baby shower sea divertido y memorable.",
  icon: LightbulbIcon,
  tone: {
    bg: 'bg-[#FDE3EC]',
    fg: 'text-[#E74D7A]'
  }
}, {
  title: "¿No tenés tiempo para preparar todo?",
  text: "Los juegos ya están armados y diseñados para usar. Ahorrate las horas de buscar ideas y crear las hojas: elegís, imprimís y disfrutás.",
  icon: ClockIcon,
  tone: {
    bg: 'bg-[#DDF2F1]',
    fg: 'text-[#15ADA8]'
  }
}, {
  title: "¿Te preocupa que nadie se enganche?",
  text: "Con este kit tenés listo: juegos para reírse, actividades en grupo y propuestas emotivas para que amigas y familiares compartan un momento inolvidable.",
  icon: UsersIcon,
  tone: {
    bg: 'bg-[#F3EADF]',
    fg: 'text-[#9A7A60]'
  }
}];
const solutionCopy = {
  title: 'Todo listo para un Baby Shower divertido, organizado y memorable.',
  text: 'Los juegos ya están pensados, armados y diseñados para vos. Ahorrate las horas buscando ideas y preparando hojas, sin tener que contratar un planner o animador para organizar los juegos.'
};
export function PainPoints() {
  return <section aria-labelledby="pain-title" className="bg-[#FBF6EE] py-12 md:py-20" data-id="element-252" data-mp="1zca5fafpkp48">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-253" data-mp="2n2w2k6o6cozg">
        <header className="mx-auto max-w-2xl text-center" data-id="element-254" data-mp="2ru4bz2pi8acm">
          <p className="inline-flex items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-255" data-mp="2rvp5qq3zvp9f">
            {painCopy.eyebrow}
          </p>
          <h2 id="pain-title" className="mx-auto mt-4 max-w-[24ch] font-display text-[1.65rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2.1rem] md:text-[2.4rem]" data-id="element-256" data-mp="2spg2ulndza2r">
            {painCopy.title}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[16px] leading-relaxed text-body md:mt-4 md:text-[17px]" data-id="element-257" data-mp="2istj606sqp2b">
            {painCopy.subtitle}
          </p>
        </header>

        <ul className="mt-8 grid gap-3.5 md:mt-12 md:grid-cols-3 md:gap-5" data-id="element-258" data-mp="292qsi6n5dn75">
          {painCards.map(({
          title,
          text,
          icon: Icon,
          tone
        }) => <li key={title} className="flex gap-4 rounded-3xl border border-[#EFE4D6] bg-white p-5 shadow-[0_10px_28px_-20px_rgba(139,107,85,0.45)] md:flex-col md:gap-0 md:p-7" data-id="element-259" data-mp="201k8hnlahu95">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl md:h-12 md:w-12 ${tone.bg}`} aria-hidden="true" data-id="element-260" data-mp="ajvqjhvqm1by">
                <Icon className={`h-5 w-5 ${tone.fg}`} strokeWidth={1.75} data-id="element-261" data-mp="fhovk7lb0pan" />
              </span>
              <div className="md:mt-5" data-id="element-262" data-mp="kje9buzwvh2f">
                <h3 className="font-display text-[17px] font-bold leading-snug text-[#4A3A35] md:text-[18px]" data-id="element-263" data-mp="kg8k8fra8f6p">{title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-body md:mt-2 md:text-[16px]" data-id="element-264" data-mp="3nz1v2ksoepx6">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="relative mx-auto mt-8 max-w-3xl overflow-hidden rounded-[2rem] border border-[#F5B4C9] bg-[#FEEAF1] px-6 py-8 text-center md:mt-12 md:px-12 md:py-10" data-id="element-265" data-mp="3sy4p7a74bbqd">
          <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#E74D7A]" aria-hidden="true" data-id="element-266" data-mp="5llvd7a0j0qc">
            <HeartIcon className="h-5 w-5 fill-current" strokeWidth={1.5} data-id="element-267" data-mp="3567lk6dtnq0c" />
          </span>
          <h3 className="mx-auto mt-4 max-w-[26ch] font-serif text-[1.5rem] font-semibold italic leading-snug text-[#4A3A35] [text-wrap:balance] md:text-[1.85rem]" data-id="element-268" data-mp="397swhm6spu7w">
            {solutionCopy.title}
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-[16px] leading-relaxed text-body md:text-[17px]" data-id="element-269" data-mp="2l4cupsx6ucbm">{solutionCopy.text}</p>
          <div className="mx-auto mt-5 flex justify-center gap-1.5" aria-hidden="true" data-id="element-270" data-mp="2v4n4t4nxf3mk">
            <span className="h-1.5 w-8 rounded-full bg-[#F5B4C9]" data-id="element-271" data-mp="38vs2w2bnbnus" />
            <span className="h-1.5 w-8 rounded-full bg-[#93D1CE]" data-id="element-272" data-mp="38txgskon1pp4" />
          </div>
        </div>
      </div>
    </section>;
}